export type TourStep = {
  /** CSS selector for the element the spotlight highlights. */
  targetSelector: string;
  title: string;
  body: string;
  /** Which side of the target the coachmark card opens on. Defaults to "right". */
  placement?: "right" | "top" | "bottom";
  /** Circular spotlight hole, for round targets like the mobile Create FAB. */
  round?: boolean;
};

/** Shared between the step lists below so the two can't drift. */
const COPY = {
  create: {
    title: "Start with Create",
    body: "Upload a track or start a release here.",
  },
  library: {
    title: "Your audio library",
    body: "Your tracks and releases live here, ready to enhance, organize, and publish.",
  },
  sales: {
    title: "Sales & Earnings",
    body: "Track every sale and connect your payout account to get paid.",
  },
  progress: {
    title: "Track your progress",
    body: "Follow these steps to finish setting up. You can come back anytime",
  },
} as const;

/**
 * Desktop tour: every target lives in the Audiolab left sidebar
 * (`LeftNav type="account"`), so the coachmark card opens to the right of the
 * highlighted element. Selectors reuse existing `data-testid`s where they
 * exist; `data-tour="create"` and the tracker's testid were added for this.
 */
export const AUDIOLAB_TOUR_STEPS_DESKTOP: TourStep[] = [
  { targetSelector: '[data-tour="create"]', ...COPY.create },
  { targetSelector: '[data-testid="nav-audio"]', ...COPY.library },
  { targetSelector: '[data-testid="nav-sales"]', ...COPY.sales },
  {
    targetSelector: '[data-testid="sidebar-get-started-tracker"]',
    ...COPY.progress,
  },
];

/**
 * Mobile tour: the sidebar is gone, so the first three steps spotlight the
 * fixed bottom tab bar and their cards open above each target. The tracker is a
 * banner at the top of the library rather than a tab, so the last step's card
 * opens below it instead.
 */
export const AUDIOLAB_TOUR_STEPS_MOBILE: TourStep[] = [
  {
    targetSelector: '[data-tour="mobile-create"]',
    ...COPY.create,
    placement: "top",
    round: true,
  },
  {
    targetSelector: '[data-testid="mobile-tabbar-audio"]',
    ...COPY.library,
    placement: "top",
  },
  {
    targetSelector: '[data-testid="mobile-tabbar-earnings"]',
    ...COPY.sales,
    placement: "top",
  },
  {
    targetSelector: '[data-testid="mobile-get-started-banner"]',
    ...COPY.progress,
    placement: "bottom",
  },
];
